import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Flex, Box } from 'roo-ui/components';

export const FullscreenWrapper = styled(Box)`
  width: 100%;
  height: auto;
  display: flex;
  position: fixed;
  z-index: 500;
  background: rgba(0, 0, 0, 0.9);
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
`;

export const FullscreenContainer = styled(Flex)`
  width: 100%;
  height: 100%;
  position: relative;
  flex-direction: column;
`;

const FullscreenTakeover = React.forwardRef(({ children, ...rest }, ref) => (
  <FullscreenWrapper>
    <FullscreenContainer {...rest} ref={ref}>
      {children}
    </FullscreenContainer>
  </FullscreenWrapper>
));

FullscreenTakeover.displayName = 'FullscreenTakeover';

FullscreenTakeover.propTypes = {
  children: PropTypes.node,
};

FullscreenTakeover.defaultProps = {
  children: null,
};

export default FullscreenTakeover;
